// extracted by mini-css-extract-plugin
export default {"artistPaneSection":"udBMsM0knRgTTE7G6EUY","artistPaneLink":"BUHkmrmhkVMvpo2dAHJj"};